module.exports = {
    // [number]: Current value
    current: 0,
    
    // [number]: Change per second
    speed: 0,
    
    // [number]: Change per second plus direction (ie can be negative)
    velocity: 0,
    
    // [number]: Amount value has changed in the most recent frame
    frameChange: 0
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/defaults/value-state.js
 ** module id = 51
 ** module chunks = 0
 **/